/* HOTHANNI "Hannibunny" Shop-Bunny (Codext). Regelbasiert, keine externe KI, keine Daten an Dritte. */
(() => {
  if (window.__hhBuddy) return; window.__hhBuddy = true;

  const init = () => {
    const root = document.getElementById('hh-buddy');
    const dataEl = document.getElementById('hh-buddy-data');
    if (!root || !dataEl) return;
    let D = {};
    try { D = JSON.parse(dataEl.textContent); } catch (e) { return; }

    const $ = (s) => root.querySelector(s);
    const btn = $('.hh-buddy__btn'), panel = $('.hh-buddy__panel'), bubble = $('.hh-buddy__bubble');
    const bubbleText = $('.hh-buddy__bubble-text'), log = $('.hh-buddy__log'), chips = $('.hh-buddy__chips');
    const form = $('.hh-buddy__form'), input = form.querySelector('input');
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const money = (c) => (c / 100).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
    const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (m) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m]));
    const pick = (a) => a[Math.floor(Math.random() * a.length)];
    const ss = { get: (k) => { try { return sessionStorage.getItem(k); } catch (e) { return null; } }, set: (k, v) => { try { sessionStorage.setItem(k, v); } catch (e) {} } };

    let cart = typeof D.cart === 'number' ? D.cart : 0;
    const T = D.threshold || 6900;
    const missing = () => Math.max(0, T - cart);
    const P = D.product || null;
    const t = P ? `<b>${esc(P.title)}</b>` : '';

    /* ---------- Sprüche ---------- */
    const CAT = {
      vibe: [`Summ, summ 🐝 ${t} hat mehr Power als dein Wecker am Montag.`, `Ich bin nur ein Hase, aber bei ${t} werden sogar meine Ohren nervös 😳`],
      pressure: [`Druckwellen statt Alltagsdruck 🌊 ${t} kümmert sich drum.`, `Kein Rumgefummel, einfach auflegen und zurücklehnen 😌 ${t} macht den Rest.`],
      rabbit: [`Ein Hase, der einen Rabbit empfiehlt? Ehrensache 🐰`, `Doppelt hält besser, sagt meine Oma. Und ${t} gibt ihr recht.`],
      anal: [`Hintertür-Tipp vom Hasen: langsam starten und Gleitgel nicht vergessen 😉`, `Neugierig? ${t} ist ein guter Grund, es auszuprobieren 🍑`],
      ring: [`Länger durchhalten als ein Hase? Mit ${t} schon eher 😏`, `Kleiner Ring, große Wirkung 💍 Fast romantisch.`],
      stroker: [`Solo-Session deluxe 🙌 Etwas Gleitgel dazu und du bist im Hasenhimmel.`, `${t}: weil deine Hand auch mal Urlaub verdient hat 🏖️`],
      dildo: [`Klassiker bleibt Klassiker. ${t} sagt mehr als tausend Worte 😳`, `Ich hab ja nur Pfoten, aber ${t} würd ich sofort einpacken.`],
      balls: [`Beckenboden-Training, das Spaß macht? Endlich mal Sport, den ich verstehe 🏋️`],
      bondage: [`Fesselnde Angelegenheit 🔗 Vorher ein Safeword ausmachen, sagt der Hase.`],
      whip: [`Klatsch! 👋 Hab mich kurz erschreckt. Erst sanft testen, dann steigern.`],
      mask: [`Augen zu und nur noch fühlen 🙈 Das ist sogar mein Spezialgebiet.`],
      fetish: [`Ein bisschen Fetisch hat noch keinem geschadet 😈 Absprechen, genießen, wiederholen.`],
      lingerie: [`Uff 🔥 In ${t} siehst du garantiert besser aus als ich in meinem Fell.`, `Auspacken ist das neue Einpacken 🎁`],
      massage: [`Massage-Abend? Licht dimmen, Handy weg, los geht's 🕯️`],
      game: [`Spieleabend, aber in spannend 🎲 Wer verliert, muss … du weißt schon.`],
      fun: [`Für die Lacher beim JGA oder einfach so 😜`],
      lube: [`Gleitgel ist wie Butter auf dem Brötchen: geht ohne, aber warum sollte man 💧`],
      condom: [`Safety first, Spaß second, Hase third 🛡️`],
      default: [`${t}? Gute Wahl, du hast offensichtlich Geschmack 😏`, `Psst 🤫 ${t} ist einer meiner Lieblinge hier.`]
    };

    const shipLine = () => {
      if (!P) return missing() > 0 ? `Noch <b>${money(missing())}</b> bis zum Gratisversand 🚚` : `Dein Versand ist schon gratis 🎉`;
      if (cart >= T) return `Dein Versand ist sowieso schon gratis 🎉`;
      const rest = T - cart - P.price;
      return rest <= 0 ? `Mit dem Teil knackst du sogar den Gratisversand 🚚` : `Danach fehlen dir nur noch <b>${money(rest)}</b> bis zum Gratisversand.`;
    };

    const contextLine = () => {
      switch (D.kind) {
        case 'product':
          if (P && !P.available) return `Mist, ${t} ist gerade weg 😢 Schau dir unten ähnliche Sachen an.`;
          return pick(CAT[P && P.cat] || CAT.default);
        case 'collection':
          return pick([
            `${D.collectionCount} Teile in „${esc(D.collection)}“ 👀 Lass dir Zeit, ich warte.`,
            `Zu viel Auswahl? Sortier nach Preis oder frag mich einfach 🐰`,
            `„${esc(D.collection)}“, gute Wahl. Ich tu so, als hätte ich nichts gesehen 🙈`
          ]);
        case 'cart':
          return D.count > 0 ? (missing() > 0 ? `Noch <b>${money(missing())}</b> bis Gratisversand. So kurz vorm Ziel aufhören? 😏` : `Gratisversand geknackt 🎉 Ab zur Kasse, ich halt die Tür auf.`) : `Deine Kiste ist noch leer 📦 Soll ich dir was zeigen?`;
        case 'search':
          return D.searchCount > 0 ? `${D.searchCount} Treffer für „${esc(D.search)}“ 🔎 Nicht schlecht.` : `Hmm, dazu hab ich nichts gefunden 🙈 Frag mich, vielleicht hilft ein anderes Wort.`;
        case 'home':
          return pick([`Hi, ich bin Hannibunny 🐰 Sag mir, worauf du Lust hast, ich zeig dir den Weg.`, `Psst, ich bin Hannibunny 🐰 Diskret, frech und immer hier unten.`]);
        default:
          return `Hi, ich bin Hannibunny 🐰 Brauchst du Hilfe? Klick mich an.`;
      }
    };

    /* ---------- Antworten ---------- */
    const A = {
      discreet: () => `Diskretion ist bei uns Ehrensache 🤫 Dein Paket kommt im neutralen Karton, ohne Absender drauf. Nicht mal der Postbote ahnt was.`,
      shipping: () => `Versand kostet ${money(D.shipping || 495)}, ab ${money(T)} ist er gratis. ${missing() > 0 ? `Dir fehlen gerade noch <b>${money(missing())}</b>.` : `Und du hast den Gratisversand schon geknackt 🎉`} Bei Artikeln auf Lager steht die Lieferzeit direkt auf der Produktseite.`,
      payment: () => `Bezahlen kannst du ganz bequem, z. B. mit PayPal, Klarna, Apple Pay oder Karte. Was genau geht, siehst du an der Kasse 🔒`,
      returns: () => `Alles zu Widerruf und Rücksendung steht hier: <a href="/policies/refund-policy">Widerrufsrecht</a>.`,
      product: () => P ? (P.desc ? `Kurz gesagt: ${esc(P.desc)}<br><a href="#" data-buddy="desc">Ganze Beschreibung ansehen ↓</a>` : `Alle Details stehen unten in der Beschreibung 👇`) : `Öffne ein Produkt, dann erzähl ich dir was dazu 😉`,
      combo: () => D.tip ? { html: `Mein Tipp dazu 👇`, tip: D.tip } : `Ein gutes Gleitgel passt eigentlich immer 💧 <a href="/collections/gleitmittel-auf-wasserbasis">Hier entlang</a>`,
      help: () => `Sag mir einfach, was du suchst, z. B. „Vibrator“, „Dessous“ oder „Gleitgel“, und ich schick dich hin 🐰`,
      contact: () => `Die häufigsten Fragen beantworten wir hier: <a href="/pages/faq">Fragen &amp; Antworten</a>. Für alles andere schreib uns einfach.`,
      hello: () => pick([`Hey du 💋 Was darf's sein?`, `Hallöchen 🐰 Womit kann ich dir helfen?`]),
      thanks: () => pick([`Gerne 😘`, `Immer doch, dafür bin ich da 🐰`]),
      who: () => `Ich bin Hannibunny, das Shop-Bunny von HOTHANNI 🐰 Kein Mensch, keine echte KI, aber ich kenn mich hier ganz gut aus.`,
      discount: () => `Rabattcodes trägst du ganz einfach an der Kasse ein 🎟️`
    };

    const RULES = [
      [/diskret|neutral|absender|nachbar|verpack|post(bote)?|anonym/, 'discreet'],
      [/versand|liefer|wann|dauer|kosten|porto|dhl|gratis|kostenlos/, 'shipping'],
      [/bezahl|zahl|paypal|klarna|apple|kredit|karte|rechnung|vorkasse|bitcoin/, 'payment'],
      [/rück|retour|widerruf|umtausch|zurück/, 'returns'],
      [/was kann|beschreib|funktion|größe|groesse|material|länge|laenge|akku|wasserdicht|lautstärke|leise/, 'product'],
      [/dazu|passt|kombi|zubehör|empfehl|tipp/, 'combo'],
      [/kontakt|hilfe|support|mail|telefon|faq/, 'contact'],
      [/rabatt|gutschein|code|coupon|sale|angebot/, 'discount'],
      [/wer bist|bist du|name|mensch|bot|ki\b/, 'who'],
      [/^(hi|hallo|hey|moin|servus|huhu)\b/, 'hello'],
      [/danke|thx|merci/, 'thanks']
    ];

    const chipsFor = () => {
      const base = [['🤫 Wie diskret?', 'discreet'], ['🚚 Versand & Kosten', 'shipping'], ['🔒 Bezahlung', 'payment'], ['↩️ Rückgabe', 'returns']];
      if (D.kind === 'product') return [['✨ Was kann das Teil?', 'product'], ['💡 Was passt dazu?', 'combo']].concat(base.slice(0, 3));
      return [['🔎 Hilf mir suchen', 'help']].concat(base);
    };

    /* ---------- Chat-Log ---------- */
    const addMsg = (html, who) => {
      const m = document.createElement('div');
      m.className = `hh-buddy__msg hh-buddy__msg--${who}`;
      m.innerHTML = html;
      log.appendChild(m);
      log.scrollTop = log.scrollHeight;
      return m;
    };
    const addTip = (tp) => {
      const c = document.createElement('div');
      c.className = 'hh-buddy__tip';
      c.innerHTML = `<a href="${esc(tp.url)}" class="hh-buddy__tip-img">${tp.img ? `<img src="${esc(tp.img)}" alt="" loading="lazy">` : ''}</a>` +
        `<div class="hh-buddy__tip-body"><a href="${esc(tp.url)}">${esc(tp.title)}</a><span>+ ${money(tp.price)}</span></div>` +
        `<button type="button" class="hh-buddy__tip-add">Dazu packen</button>`;
      c.querySelector('.hh-buddy__tip-add').addEventListener('click', (e) => addToCart(tp, e.currentTarget));
      log.appendChild(c);
      log.scrollTop = log.scrollHeight;
    };
    const botSay = (answer) => {
      const typing = addMsg('<span class="hh-buddy__typing"><i></i><i></i><i></i></span>', 'bot');
      setTimeout(() => {
        typing.remove();
        if (answer && typeof answer === 'object') { addMsg(answer.html, 'bot'); if (answer.tip) addTip(answer.tip); }
        else addMsg(answer, 'bot');
      }, reduce ? 0 : 550);
    };
    const answerFor = (text) => {
      const q = text.toLowerCase().trim();
      for (const [re, key] of RULES) if (re.test(q)) return A[key]();
      const enc = encodeURIComponent(text.trim());
      return `Da schnüffel ich direkt im Shop für dich 🔎 <a href="/search?q=${enc}&type=product">Alles zu „${esc(text.trim())}“ ansehen →</a><br>Oder frag mich nach Versand, Diskretion oder Bezahlung.`;
    };

    const addToCart = async (tp, button) => {
      button.disabled = true; button.textContent = '…';
      try {
        const r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: tp.variant, quantity: 1 }], sections: 'cart-drawer' }) });
        const added = await r.json();
        if (!r.ok) throw new Error('add');
        const c = await (await fetch('/cart.js')).json();
        c.sections = added.sections || {};
        cart = c.total_price;
        button.textContent = 'Drin ✓';
        button.dispatchEvent(new CustomEvent('variant:add', { bubbles: true, detail: { items: added.items || [added], cart: c, blockCartDrawerOpening: true } }));
        if (c.sections['cart-drawer']) document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart: c } }));
        else document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        botSay(missing() > 0 ? `Ab in die Kiste 💋 Noch <b>${money(missing())}</b> bis Gratisversand.` : `Ab in die Kiste 💋 Und zack, Gratisversand geknackt 🎉`);
      } catch (e) {
        button.disabled = false; button.textContent = 'Dazu packen';
        botSay(`Uff, das hat nicht geklappt 🙈 Probier's direkt auf der <a href="${esc(tp.url)}">Produktseite</a>.`);
      }
    };

    /* ---------- Öffnen / Schließen ---------- */
    let opened = false;
    const openPanel = () => {
      hideBubble();
      root.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
      if (!opened) {
        opened = true;
        addMsg(`Hey, ich bin <b>Hannibunny</b> 🐰 ${contextLine().replace(/^(Hi|Psst), ich bin Hannibunny 🐰\s*/, '')}`, 'bot');
        if (P && P.available) addMsg(shipLine(), 'bot');
        chips.innerHTML = '';
        chipsFor().forEach(([label, key]) => {
          const b = document.createElement('button');
          b.type = 'button'; b.className = 'hh-buddy__chip'; b.textContent = label;
          b.addEventListener('click', () => { addMsg(esc(label.replace(/^\S+\s/, '')), 'me'); botSay(A[key]()); });
          chips.appendChild(b);
        });
      }
      setTimeout(() => { if (window.matchMedia('(min-width: 700px)').matches) input.focus({ preventScroll: true }); }, 250);
    };
    const closePanel = () => { root.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false'); };
    btn.addEventListener('click', () => (root.classList.contains('is-open') ? closePanel() : openPanel()));
    $('.hh-buddy__close').addEventListener('click', closePanel);
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && root.classList.contains('is-open')) closePanel(); });
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const v = input.value.trim(); if (!v) return;
      addMsg(esc(v), 'me'); input.value = '';
      botSay(answerFor(v));
    });
    log.addEventListener('click', (e) => {
      const a = e.target.closest('[data-buddy="desc"]');
      if (!a) return;
      e.preventDefault(); closePanel();
      const d = document.querySelector('.product-info [is="accordion-disclosure"], .product-info details, .product-info .accordion');
      if (d) { d.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' }); const s = d.matches('details') ? d : d.querySelector('details'); if (s && !s.open) s.querySelector('summary')?.click(); }
    });

    /* ---------- Sprechblase ---------- */
    let bubbleTimer = null;
    const showBubble = (html, ms) => {
      if (root.classList.contains('is-open')) return;
      bubbleText.innerHTML = html;
      root.classList.add('has-bubble');
      clearTimeout(bubbleTimer);
      bubbleTimer = setTimeout(hideBubble, ms || 9000);
    };
    function hideBubble() { root.classList.remove('has-bubble'); clearTimeout(bubbleTimer); }
    bubble.addEventListener('click', (e) => { if (e.target.closest('.hh-buddy__bubble-x')) { hideBubble(); ss.set('hh-buddy-quiet', String((+ss.get('hh-buddy-quiet') || 0) + 1)); return; } openPanel(); });

    document.addEventListener('cart:change', (e) => { const c = e.detail && e.detail.cart; if (c && typeof c.total_price === 'number') cart = c.total_price; });

    root.hidden = false;
    requestAnimationFrame(() => root.classList.add('is-ready'));
    const quiet = (+ss.get('hh-buddy-quiet') || 0) >= 2;
    if (!quiet) setTimeout(() => showBubble(contextLine()), D.kind === 'product' ? 2500 : 4000);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
